export function useReadonly(props) {
  if (props.isReadonly) {
    return {
      menuIsOpen: false,
      isClearable: false,
      isSearchable: false,
      openMenuOnFocus: false,
      openMenuOnClick: false,
      inputProps: {
        readOnly: true
      },
      onKeyDown: evt => {
        if (['ArrowDown', 'ArrowUp', 'Spacebar', ' ', 'Enter'].includes(evt.key)) {
          evt.preventDefault();
        }
      }
    };
  }
  return {};
}